<template>
  <div
    class="down-tip transition-all duration-300 flex items-center justify-between relative text-12 px-15 text-color-0  overflow-hidden"
   >
    <div style="max-width: 220px;display: flex;align-items: center;">
      <img src="../../assets/images/slogo.png" style="width: 44px;margin: 0 5px 0 20px;"/>
    </div>
    <div style="display: flex;align-items: center;width: 100%;justify-content: center;flex-direction: row;box-sizing: border-box;">
      <div style="width: 100%;display: flex;align-items: center;justify-content: normal;">
        <span class="two-line">Baixe Nosso APP,<br>Ganhe Super Prêmios!</span>
        <img src="../../assets/images/cash.png" style="width: clamp(20px,8vw,38px);">
      </div>
      <div style="display: flex;align-items: center;  background: linear-gradient(0deg, #23d8db 1.92%, #23db8c 96.15%); border-radius: 10px; ">
        <a href="/down" target="_blank" class="download-btn-link">
          <div class="download-btn">
          
            <div class="download-btn-content">
              <img src="../../assets/images/icon-download.png" style="width: clamp(16px,5vw,28px);"/>
              <span class="download-btn-text">{{$t("A0013") }}</span>
            </div>
          </div>
        </a>
      </div>
      <div
        @click="handleDownClose"
        class="close-icon"
      >
        <i class="sysicon-new-clean-2 text-13" style="color: #fff;"></i>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useNav } from "@/hooks/useNav.js";
import { defineEmits, ref } from "vue";
const nav = useNav();
const emit = defineEmits(["onclose"]);
// 处理关闭操作
const handleDownClose = () => {
  emit("onclose");
};
const downloadClicked = ref(false)
const deferredPrompt = ref(null)

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault()
  deferredPrompt.value = e
})
const ua = navigator.userAgent
const isAndroid = () => /Android/i.test(ua)
const isIOS = () => /iPhone|iPad|iPod/i.test(ua)
const isPWA = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true
function installApk(){
  if (isPWA()) {
    location.href = "/home"
    return
  }

  // 有原生PWA安装能力
  if (deferredPrompt.value) {
    deferredPrompt.value.prompt()

    deferredPrompt.value.userChoice.then((res) => {
      deferredPrompt.value = null

      if (res.outcome === 'accepted') {
        location.href = "/home"
      }
    })

    return
  }

  // fallback
  if (isAndroid()) {
    window.location.href = "#"
  } else if (isIOS()) {
    window.location.href = "#"
  }

  downloadClicked.value = true;

  // 方法2：直接跳转（大部分浏览器也会下载）
  // window.location.href = url;
}

</script>
<style lang="scss" scoped>
.down-tip {
  height: var(--app-download-height);
  background-image: url('@/assets/images/icon/green-default.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.two-line {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 1rem;
  font-size: clamp(.4rem,3vw,.8rem);
  font-weight: 500 !important;
  margin-right:5px;
  color: white;
}
.download-btn-link {
  display: block;
}
.download-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: clamp(80px, 26vw, 145px);
  height: clamp(20px, 10vw, 40px);
  border-radius: 10px;
  overflow: hidden;
}
.download-btn-bg {
 
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  z-index: 0;
}
.download-btn-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.download-btn-text {
  color: #000;
  font-weight: bold;
  font-size: clamp(8px, 4vw, 18px);
}
.close-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-left: 8px;
  cursor: pointer;
}
</style>
